module.exports = __webpack_public_path__ + "img/excelIcon.e74cdeac.svg";